module.exports = __webpack_public_path__ + "img/38754-145.1bc71292.jpg";